import {FC} from 'react'

const ActiveFilterItem: FC<{
    label: string
    value: string
    html_for: string
}> = ({label, value, html_for}) => {
    return (
        <>
            <div className="element-border flex">
                <span className="active-border">
                    <span className="selection-filters flex">
                        {label}
                        {/*TODO label dziala tylko dla multi select !!!*/}
                        <label className="label-icon-x flex" htmlFor={'filter_' + html_for}>
                            <span className="icon-delete"></span>
                        </label>
                    </span>
                </span>
            </div>
        </>
    )
}

export default ActiveFilterItem
